import { useQuery } from "@apollo/client";
import { useContext, useEffect, useState } from "react";

import { MAX_POLLINGS_NUMBER, POLL_INTERVAL } from "../../configs";
import { MatchContext } from "../../context";
import {
  SET_DATA,
  SET_FILTERED_HIGHLIGHTED_STOCKPILES,
} from "../../reduce/actionTypes";
import {
  getResponseNextLevelData,
  prepareTableRowsData,
} from "../create-table-data";
import { prepareStockpiles } from "../prepare-stockpiles-for-equipment-avl";

const usePollStockpiles = (
  query: any,
  stockpilesTableFeatures: any,
  dataType: string
) => {
  const { state, dispatch } = useContext(MatchContext);
  const [pollCounter, setPollCounter] = useState(0);
  const [rows, setRows] = useState([]);

  const { data, loading, error, stopPolling } = useQuery(query, {
    variables: {
      requestId: state.requestId,
    },
    pollInterval: POLL_INTERVAL,
    notifyOnNetworkStatusChange: true,
  });

  useEffect(() => {
    const tableData = data
      ? getResponseNextLevelData(getResponseNextLevelData(data[dataType])[0])
      : null;

    if (loading) {
      setPollCounter(pollCounter + 1);
    }

    if (tableData?.length && tableData[0]) {
      new Promise((resolve, reject) => {
        resolve(
          dispatch({
            type: SET_FILTERED_HIGHLIGHTED_STOCKPILES,
            payload: tableData,
          })
        );
      }).then(() => {
        stopPolling();
        setPollCounter(0);

        dispatch({
          type: SET_DATA,
          payload: { loadingStockpilesData: false },
        });
        return;
      });
    }
  }, [loading]);

  useEffect(() => {
    if (pollCounter >= MAX_POLLINGS_NUMBER) {
      stopPolling();
      setPollCounter(0);
      dispatch({
        type: SET_DATA,
        payload: { loadingStockpilesData: false },
      });
    }
  }, [pollCounter]);

  useEffect(() => {
    if (error || state.userInputError) {
      stopPolling();
      setPollCounter(0);

      dispatch({
        type: SET_DATA,
        payload: { loadingStockpilesData: false },
      });
    }
  }, [error, state.userInputError]);

  useEffect(() => {
    if (data) {
      const tableData = getResponseNextLevelData(data[dataType])[0];
      const rowsData = prepareTableRowsData(tableData, stockpilesTableFeatures);

      if (rowsData[0].stockpiles) {
        const stockpiles = prepareStockpiles(rowsData[0].stockpiles);
        dispatch({
          type: SET_DATA,
          payload: { stockpiles },
        });
      }

      setRows(rowsData);
    } else {
      dispatch({
        type: SET_DATA,
        payload: { loadingStockpilesData: true },
      });
    }
  }, [data]);

  return { rows, error: error || state.userInputError };
};

export default usePollStockpiles;
